import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { ClientInfo } from "../../../../../api/types/clientTypes";
import type { ClientInfoExtended } from "../../../../../api/types/svTypes";

export interface Client {
  clientInfo: ClientInfoExtended;
  clients: ClientInfo[];
}

export const ClientContext = createContext<Client | undefined>(undefined);

export const useBiClientContext = () => {
  const client = use(ClientContext);
  return defined(client);
};
